module.exports = __webpack_public_path__ + "static/media/left-caret-white.113f4729.svg";